<template>
  <div id="app">
    
    <EstilloDataManager />
    
  </div>
</template>

<script>
import EstilloDataManager from './components/EstilloDataManager.vue'

export default {
  name: 'App',
  components: {
    EstilloDataManager,
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  margin-bottom: 60px;
}
</style>
